import styled from 'styled-components';

export const Text = styled.span`
  font-size: 1.25rem;
`;
export const Title = styled.p`
  margin-top: 10px;
  margin-left: 0px;
  position: absolute;
  font-size: 0.8571428571428571em;
  font-style: inherit;
  line-height: 1.3333333333333333;
  color: var(--ds-text-lowEmphasis, var(--ds-text-lowEmphasis, #6b778c));
  font-weight: 600;
  display: inline-block;
  margin-bottom: 4px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
`;

export const InpuTypeDate = styled.input`
  height: 40px;
  margin-top: 30px;
  background-color: ${(props) => (props.disabled ? `#FAFBFC` : `#fafbfc`)};
  border: 2px solid;
  border-color: ${(props) => (props.disabled ? `#FAFBFC` : ` #dfe1e6`)};
  border-radius: 3px;
  box-sizing: border-box;
  padding: 10px 20px;
  color: ${(props) => (props.disabled ? `#a5adba` : ` inherit`)};
  cursor: inherit;
  font-size: 14px;
  min-width: 0;
  width: 100%;
  cursor: ${(props) => (props.disabled ? `not-allowed` : `auto`)};
  line-height: 1.4285714285714286;
`;
